/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * BBook trade request
 */
export interface BBookOrderRequest {
  /**
   * Pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  pairIds: Array<number>;
  /**
   * Trade direction.
   */
  side: BBookOrderRequest.SideEnum;
  /**
   * Qty in base asset.
   */
  qty: number;
}
export namespace BBookOrderRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
